import { Cookies } from 'react-cookie';
import { COOKIES } from '../../constants/misc.js';

function getAuthHeader(bearerToken) {
    const cookies = new Cookies();
    const token = bearerToken || cookies.get(COOKIES.token);
    if (!token)
        return;
    return { token: `Bearer ${token}` };
}

export { getAuthHeader };
//# sourceMappingURL=getAuthHeader.js.map
